import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { Separator } from '../../Shared/Separator/Separator';
import { ConversationDto } from '@/Domain/api/Conversation/dto/Conversation.dto';
import { ConversationTopicDescription } from '@/Domain/components/Inbox/ConversationTopic/ConversationTopicDescription';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/Domain/components/Shared/Tooltip/Tooltip';
import { useSubscription } from '@/Domain/components/SubscriptionProvider';
import { ConversationExperimentEnum } from '@/Domain/enum/ConversationExperiment.enum';
import { ConversationExperimentStateEnum } from '@/Domain/enum/ConversationExperimentState.enum';
import { ConversationHelper } from '@/Domain/helper/Conversation.helper';
import { useConversationTopicsList } from '@/Domain/hooks/Conversation/useConversationTopicsList.hook';

type Props = {
  conversation: ConversationDto;
};

export const ConversationTopic = ({ conversation }: Props) => {
  const { t } = useTranslation('inbox_v2');
  const { getConfig, isFetched } = useSubscription();
  const isTopicActive = (isFetched ? getConfig('topics') : true) as boolean;

  const { hasFilledTopic, isLoading } = useConversationTopicsList();

  const experiment = ConversationHelper.getExperimentByKey(
    conversation.single_label_experiments,
    ConversationExperimentEnum.ConversationTopic,
  );

  const isTopicInProgress = experiment?.state === ConversationExperimentStateEnum.Pending;

  return (
    <>
      <Separator />
      <Tooltip>
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between gap-2">
            <section className="text-foreground-subtle flex gap-1">
              <p className="font-semibold text-foreground-subtle">
                {t('conversation_details.topic.title')}
              </p>
              <TooltipTrigger>
                <Icon icon="mingcute:information-line" />
              </TooltipTrigger>
              <TooltipContent className="absolute left-3 -translate-y-14 -translate-x-1/3 w-[200px]">
                {isTopicInProgress ? t('tooltip.topic_in_progress') : t('tooltip.topic')}
              </TooltipContent>
            </section>
          </div>
          <div>
            <ConversationTopicDescription
              experiment={experiment}
              isTopicActive={isTopicActive}
              hasFilledTopic={!!hasFilledTopic}
              isLoading={isLoading}
            />
          </div>
        </div>
      </Tooltip>
    </>
  );
};
